(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bb-black-vip"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('bb-vip-campaign'))customElements.define('bb-vip-campaign',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();clearInterval(this.clock);this.controller=new AbortController();
    this.addEventListener('click',event=>{
      const link=event.target.closest('[data-vip-cta] a[href]');
      if(!link||!this.contains(link)||link.getAttribute('aria-disabled')==='true')return;
      window.dataLayer=window.dataLayer||[];window.dataLayer.push({event:'vip_group_click',campaign:'black_november',variant:this.dataset.variant,placement:link.closest('[data-vip-cta]').dataset.vipCta,page_path:location.pathname});
    },{signal:this.controller.signal});
    this.countdown=this.querySelector('[data-countdown]');
    if(this.countdown&&this.updateCountdown())this.clock=setInterval(()=>this.updateCountdown(),1000);
  }
  updateCountdown(){
    const box=this.countdown,value=box.dataset.end||'',target=Date.parse(value),valid=/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,3})?)?(Z|[+-]\d{2}:\d{2})$/.test(value)&&Number.isFinite(target);
    const digits=box.querySelector('[data-countdown-digits]'),message=box.querySelector('[data-countdown-message]');
    if(!valid){box.hidden=!box.hasAttribute('data-editor');digits.hidden=true;if(!box.hidden){message.hidden=false;message.textContent=box.dataset.invalid;}return false;}
    box.hidden=false;let remaining=Math.max(0,Math.floor((target-Date.now())/1000));
    digits.hidden=remaining===0;message.hidden=remaining>0;
    if(!remaining){clearInterval(this.clock);return false;}
    const values={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
    for(const [key,n]of Object.entries(values))box.querySelector('[data-'+key+']').textContent=String(n).padStart(2,'0');
    return true;
  }
  disconnectedCallback(){this.controller?.abort();clearInterval(this.clock);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blocobox-coupons"]) return;
  try {
    
(() => {
  const storageKey = 'blocobox.copied-coupon.v1';
  const choiceKey = 'blocobox.coupon-choice.v1';
  const readChoice = () => {
    try {
      const choice = JSON.parse(sessionStorage.getItem(choiceKey));
      return choice && Number.isFinite(choice.at) && Date.now() >= choice.at && Date.now() - choice.at < 86400000 ? choice : null;
    } catch { return null; }
  };
  const modeOf = (card, library) => card?.dataset.mode && card.dataset.mode !== 'inherit' ? card.dataset.mode : library.dataset.mode;
  const parseDate = value => {
    if (!value) return null;
    const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(value);
    if (!match) return NaN;
    const [, year, month, day, hour, minute] = match.map(Number);
    if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59) return NaN;
    const local = new Date(Date.UTC(year, month - 1, day, hour, minute));
    if (local.getUTCFullYear() !== year || local.getUTCMonth() !== month - 1 || local.getUTCDate() !== day) return NaN;
    return local.getTime() + 10800000;
  };
  const benefitOf = card => card.querySelector('.bb-coupon-card__benefit').textContent.trim();
  const signatureOf = card => JSON.stringify([card.dataset.code, benefitOf(card), card.dataset.scheduled === 'true', card.dataset.start.trim(), card.dataset.end.trim()]);
  const scheduleOf = (card, now = Date.now()) => {
    const scheduled = card.dataset.scheduled === 'true';
    const start = scheduled ? parseDate(card.dataset.start.trim()) : null;
    const end = scheduled ? parseDate(card.dataset.end.trim()) : null;
    const state = Number.isNaN(start) || Number.isNaN(end) || (start !== null && end !== null && start >= end) ? 'invalid' : start !== null && now < start ? 'upcoming' : end !== null && now >= end ? 'expired' : 'active';
    return {start, end, state};
  };
  const readCoupon = () => {
    try { return JSON.parse(sessionStorage.getItem(storageKey)); } catch { return null; }
  };
  const validCoupon = (coupon, library) => {
    if (!coupon || !library || library.dataset.enabled !== 'true' || typeof coupon.code !== 'string' || typeof coupon.benefit !== 'string' || coupon.code.length > 100 || coupon.benefit.length > 200 || !Number.isFinite(coupon.at) || Date.now() < coupon.at || Date.now() - coupon.at >= 86400000) return null;
    const card = [...library.querySelectorAll('[data-coupon-card]')].find(item => signatureOf(item) === coupon.signature);
    return card && card.dataset.code === coupon.code && benefitOf(card) === coupon.benefit && scheduleOf(card).state === 'active' ? coupon : null;
  };
  const copyText = async (text, container) => {
    try { if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(text); return true; } } catch {}
    const field = document.createElement('textarea');
    field.value = text;
    field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;width:1px;height:1px;';
    field.setAttribute('readonly', '');
    container.append(field);
    field.select();
    let copied = false;
    try { copied = document.execCommand('copy'); } catch {}
    field.remove();
    return copied;
  };
  const phrase = (template, coupon) => template.replace('[code]', () => coupon.code).replace('[benefit]', () => coupon.benefit);
  const remaining = (target, now, daysLabel) => {
    let seconds = Math.max(0, Math.ceil((target - now) / 1000));
    const days = Math.floor(seconds / 86400);
    seconds %= 86400;
    const hours = Math.floor(seconds / 3600), minutes = Math.floor(seconds % 3600 / 60);
    return `${days ? `${days}${daysLabel} ` : ''}${[hours, minutes, seconds % 60].map(value => String(value).padStart(2, '0')).join(':')}`;
  };
  if (!customElements.get('bb-coupon-library')) {
    customElements.define('bb-coupon-library', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.dialog = this.querySelector('dialog');
        this.cards = [...this.querySelectorAll('[data-coupon-card]')];
        document.addEventListener('click', event => {
          const removal = event.target.closest('[data-remove-coupon]');
          if (removal) { event.preventDefault(); this.removeCoupon(removal); return; }
          const opener = event.target.closest('[data-bb-coupon-open]');
          if (opener) { event.preventDefault(); if (opener.hasAttribute('data-bb-coupon-inline')) this.toggleInline(opener); else this.open(opener); }
        }, options);
        document.addEventListener('click', async event => {
          const inline = event.target.closest('[data-bb-inline-coupons]');
          if (!this.contains(event.target) && !inline) return;
          if (event.target.closest('[data-close-coupons]')) this.dialog.close();
          const button = event.target.closest('[data-copy-coupon]');
          if (!button || button.disabled || this.dataset.enabled !== 'true') return;
          const displayedCard = button.closest('[data-coupon-card]');
          const card = inline ? this.cards.find(item => item.dataset.code === displayedCard.dataset.code) : displayedCard;
          if (!card) return;
          const sourceButton = card.querySelector('[data-copy-coupon]');
          if (card.dataset.eligible !== 'true' || scheduleOf(card).state !== 'active') { this.refresh(); return; }
          button.dataset.copying = 'true';
          sourceButton.dataset.copying = 'true';
          button.disabled = true;
          sourceButton.disabled = true;
          const automatic = modeOf(card, this) === 'yampi';
          const copied = automatic || await copyText(card.dataset.code, inline || this.dialog);
          delete button.dataset.copying;
          delete sourceButton.dataset.copying;
          if (!this.isConnected) return;
          const schedule = scheduleOf(card);
          if (schedule.state !== 'active') { this.refresh(); this.announce(this.dataset[schedule.state]); return; }
          if (copied) {
            if (!this.selectCoupon(card, 'user')) {
              card.querySelector('[data-manual-copy]').hidden = false;
              this.refresh();
              (inline?.querySelector('[data-manual-copy]:not([hidden]) input') || card.querySelector('[data-manual-copy] input')).focus();
              this.announce(this.dataset.applyFailed);
              return;
            }
            card.querySelector('[data-manual-copy]').hidden = true;
            this.announce(automatic ? this.dataset.applied : this.dataset.copied);
            this.refresh();
            if (inline) inline.querySelector('[data-coupon-card][data-code="'+CSS.escape(card.dataset.code)+'"] [data-copy-coupon]')?.focus();
            else button.focus();
          } else {
            const manual = card.querySelector('[data-manual-copy]');
            manual.hidden = false;
            this.refresh();
            const field = inline?.querySelector('[data-manual-copy]:not([hidden]) input') || manual.querySelector('input');
            field.focus();
            field.select();
            this.announce(this.dataset.copyFailed);
          }
        }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => this.release(), options);
        document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refresh(); }, options);
        window.addEventListener('pageshow', () => this.refresh(), options);
        document.addEventListener('shopify:section:load', () => this.refresh(), options);
        document.addEventListener('bb:cart-rendered', () => this.refresh(), options);
        document.addEventListener('cart:change', () => queueMicrotask(() => this.refresh()), options);
        this.closest('.shopify-section')?.addEventListener('shopify:section:select', () => this.open(), options);
        this.closest('.shopify-section')?.addEventListener('shopify:block:select', () => this.open(), options);
        this.refresh();
        if (this.cards.some(card => card.dataset.scheduled === 'true')) this.timer = setInterval(() => { if (!document.hidden) this.refresh(); }, 1000);
      }
      disconnectedCallback() { this.release(); this.controller.abort(); clearInterval(this.timer); }
      announce(text) { this.querySelector('[data-copy-status]').textContent = text; }
      getCoupon() {
        if (this.removeFailed) return null;
        const stored = readCoupon(), choice = readChoice();
        if (choice?.type === 'removed' && (!stored || stored.at <= choice.at)) return null;
        return validCoupon(stored || (!this.removed && this.coupon?.manualOnly ? this.coupon : null), this);
      }
      selectCoupon(card, origin) {
        const schedule = scheduleOf(card);
        if (this.dataset.enabled !== 'true' || card.dataset.eligible !== 'true' || schedule.state !== 'active') return false;
        const previousCode = this.getCoupon()?.code;
        const coupon = {code:card.dataset.code, benefit:benefitOf(card), at:Date.now(), start:schedule.start, end:schedule.end, signature:signatureOf(card), origin};
        try { sessionStorage.setItem(storageKey, JSON.stringify(coupon)); } catch {
          if (modeOf(card, this) === 'yampi') return false;
          coupon.manualOnly = true;
          try { sessionStorage.removeItem(storageKey); } catch {}
        }
        this.coupon = coupon;
        this.removed = false;
        this.removeFailed = false;
        if (origin === 'user') this.rememberChoice('selected', coupon.code, previousCode);
        return true;
      }
      rememberChoice(type, code, previousCode) {
        const previous = this.choice || readChoice();
        const managed = Array.isArray(previous?.managedCodes) ? previous.managedCodes : [];
        this.choice = {type,code,at:Date.now(),managedCodes:[...new Set([...managed,previousCode,code].filter(value => typeof value === 'string' && value.length <= 100))].slice(-20)};
        try { sessionStorage.setItem(choiceKey, JSON.stringify(this.choice)); } catch {}
      }
      applyDefault() {
        if (this.dataset.preapply !== 'true' || this.removed || this.getCoupon() || this.choice || readChoice()) return;
        const code = (this.dataset.preapplyCode || '').trim().toUpperCase();
        if (!code) return;
        const card = this.cards.find(item => item.dataset.code.toUpperCase() === code && item.dataset.eligible === 'true' && modeOf(item, this) === 'yampi' && scheduleOf(item).state === 'active');
        if (card) this.selectCoupon(card, 'store');
      }
      updateEligibility() {
        const useCart = this.cartContext || this.dataset.context !== 'product';
        let cart = null;
        if (useCart) {
          try { cart = JSON.parse(document.querySelector('cart-drawer [data-bb-cart-data], .cart [data-bb-cart-data]')?.textContent || 'null'); } catch {}
        }
        for (const card of this.cards) {
          let eligible = card.dataset.productEligible === 'true';
          if (useCart) {
            try {
              const rule = JSON.parse(card.dataset.cartRule);
              eligible = rule.scope === 'all' || (cart?.items || []).some(item => rule.scope === 'products' && (rule.products || []).includes(item.productId) || rule.scope === 'collections' && (item.collectionIds || []).some(id => (rule.collections || []).includes(id)));
            } catch { eligible = false; }
          }
          card.dataset.eligible = String(eligible);
          card.classList.toggle('bb-coupon-card--unavailable', !eligible);
          const list = this.querySelector(eligible ? '[data-available-coupons]' : '[data-unavailable-coupons]');
          if (list && card.parentElement !== list) list.append(card);
          card.querySelector('[data-availability]')?.toggleAttribute('hidden', !eligible);
        }
        const heading = this.querySelector('[data-unavailable-heading]');
        if (heading) { heading.hidden = this.cards.every(card => card.dataset.eligible === 'true'); heading.textContent = useCart ? this.dataset.notForCart : this.dataset.notForProduct; }
      }
      removeCoupon(button) {
        const coupon = this.getCoupon();
        if (!coupon) return;
        this.coupon = null;
        this.removed = true;
        try { sessionStorage.removeItem(storageKey); } catch { this.removeFailed = true; }
        this.rememberChoice('removed', coupon.code);
        this.refresh();
        this.announce(this.dataset.removed);
        const root = button?.closest('cart-drawer') || button?.closest('.bb-cart-summary');
        const anchor = root?.querySelector('bb-cart-summary-toggle button, .bb-native-cart__checkout') || root?.closest('.cart')?.querySelector('[name="checkout"], a[href="/checkout"], a[href="/a/checkout"]');
        if (anchor) { anchor.focus(); root.querySelector('bb-cart-feedback')?.show(anchor, this.dataset.removed); }
        else if (this.dialog.open) this.dialog.querySelector('[data-copy-coupon]:not(:disabled)')?.focus();
      }
      getPricingCoupon() {
        const coupon = this.getCoupon();
        if (!coupon) return null;
        const card = this.cards.find(item => signatureOf(item) === coupon.signature);
        if (!card) return null;
        try { return {...JSON.parse(card.dataset.cartRule),id:'coupon',code:coupon.code,title:coupon.code,automatic:modeOf(card, this) === 'yampi' && !coupon.manualOnly}; } catch { return null; }
      }
      toggleInline(opener) {
        if (this.dataset.enabled !== 'true' && this.dataset.editor !== 'true') return;
        const panel = document.getElementById(opener.getAttribute('aria-controls'));
        if (!panel) return;
        this.cartContext = false;
        this.refresh();
        const opening = opener.getAttribute('aria-expanded') !== 'true';
        opener.setAttribute('aria-expanded',String(opening));
        panel.hidden = !opening;
      }
      renderInline() {
        const available = this.cards.filter(card => card.dataset.productEligible === 'true' && scheduleOf(card).state === 'active');
        document.querySelectorAll('[data-bb-inline-coupons]').forEach(panel => {
          const list = panel.querySelector('[data-inline-coupon-list]');
          if (!list) return;
          const codes = new Set(available.map(card => card.dataset.code));
          [...list.children].forEach(card => { if (!codes.has(card.dataset.code)) card.remove(); });
          available.forEach(source => {
            let card = [...list.children].find(item => item.dataset.code === source.dataset.code);
            if (!card) { card = source.cloneNode(true); card.removeAttribute('data-shopify-editor-block'); list.append(card); }
            card.className = source.className;
            card.dataset.state = source.dataset.state;
            if (card.innerHTML !== source.innerHTML) {
              const focused = card.contains(document.activeElement);
              const fieldFocused = focused && document.activeElement.tagName === 'INPUT';
              card.innerHTML = source.innerHTML;
              if (focused) card.querySelector(fieldFocused ? 'input' : '[data-copy-coupon]')?.focus({preventScroll:true});
            }
          });
          if (!available.length) { panel.hidden = true; panel.closest('[data-bb-coupon-entry]')?.querySelector('[data-bb-coupon-inline]')?.setAttribute('aria-expanded','false'); }
        });
        return available.length;
      }
      async open(opener) {
        if (this.opening || this.dialog.open || (this.dataset.enabled !== 'true' && this.dataset.editor !== 'true')) return;
        this.opening = true;
        this.opener = opener || document.activeElement;
        this.returnDrawer = opener?.closest('cart-drawer[open]');
        this.cartContext = Boolean(opener?.closest('cart-drawer, .cart, .bb-cart-summary'));
        if (this.returnDrawer) await this.returnDrawer.hide();
        if (!this.isConnected) { this.opening = false; return; }
        this.previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        this.locked = true;
        this.refresh();
        this.dialog.showModal();
        this.opening = false;
      }
      release() {
        if (!this.locked) return;
        document.body.style.overflow = this.previousOverflow;
        this.locked = false;
        if (this.isConnected && this.returnDrawer?.isConnected) this.returnDrawer.show();
        else if (this.opener?.isConnected) this.opener.focus();
        this.returnDrawer = null;
        this.cartContext = false;
        if (this.isConnected) this.refresh();
      }
      refresh() {
        const now = Date.now();
        this.updateEligibility();
        this.applyDefault();
        const coupon = this.getCoupon();
        const enabled = this.dataset.enabled === 'true' && Number(this.dataset.count) > 0;
        const selected = this.cards.find(card => card.dataset.eligible === 'true' && card.dataset.code === coupon?.code && signatureOf(card) === coupon?.signature);
        this.cards.forEach(card => {
          const schedule = scheduleOf(card, now);
          const eligible = card.dataset.eligible === 'true';
          card.dataset.state = schedule.state;
          card.classList.toggle('is-copied', card === selected);
          const label = card.querySelector('[data-state-label]');
          if (label) label.textContent = this.dataset[schedule.state];
          const button = card.querySelector('[data-copy-coupon]');
          if (button) {
            button.hidden = !eligible;
            button.disabled = !enabled || !eligible || schedule.state !== 'active' || button.dataset.copying === 'true';
            const automatic = modeOf(card, this) === 'yampi';
            button.querySelector('[data-copy-label]').textContent = schedule.state === 'active' ? card === selected ? automatic ? this.dataset.applied : this.dataset.copied : automatic ? this.dataset.apply : this.dataset.copy : this.dataset[schedule.state];
            button.setAttribute('aria-pressed', String(card === selected));
          }
          const target = schedule.state === 'upcoming' ? schedule.start : schedule.state === 'active' ? schedule.end : null;
          const timer = card.querySelector('[data-timer]');
          timer.hidden = !eligible || card.dataset.countdown === 'false' || target === null;
          if (!timer.hidden) card.querySelector('[data-timer-text]').textContent = `${schedule.state === 'upcoming' ? this.dataset.startsIn : this.dataset.endsIn} ${remaining(target, now, this.dataset.days)}`;
          const invalid = card.querySelector('[data-schedule-error]');
          if (invalid) invalid.hidden = schedule.state !== 'invalid';
          if (schedule.state !== 'active') { const manual = card.querySelector('[data-manual-copy]'); if (manual) manual.hidden = true; }
        });
        const inlineCount = this.renderInline();
        document.querySelectorAll('[data-bb-coupon-entry]').forEach(entry => {
          entry.hidden = (!enabled || entry.querySelector('[data-bb-coupon-inline]') && !inlineCount) && this.dataset.editor !== 'true';
          entry.classList.toggle('has-copied-coupon', Boolean(selected));
          const status = entry.querySelector('[data-bb-coupon-status]');
          const text = selected ? phrase(modeOf(selected, this) === 'yampi' && !coupon.manualOnly ? this.dataset.statusAuto : this.dataset.status, coupon) : this.dataset.discover;
          if (status && status.textContent !== text) status.textContent = text;
          const check = entry.querySelector('[data-bb-coupon-check]');
          if (check) check.hidden = !selected;
        });
        const selectedCard = coupon && this.cards.find(card => signatureOf(card) === coupon.signature);
        const selectedMode = selectedCard ? modeOf(selectedCard, this) : this.dataset.mode;
        this.querySelector('[data-coupon-footer]').textContent = selectedMode === 'manual' ? this.dataset.footerManual : this.dataset.footerAuto;
        const stateKey = JSON.stringify([coupon?.signature, coupon?.at, coupon?.manualOnly, this.dataset.enabled, selectedMode]);
        if (stateKey !== this.stateKey) {
          this.stateKey = stateKey;
          document.dispatchEvent(new CustomEvent('bb:coupon-state'));
        }
      }
    });
  }
  if (!customElements.get('bb-coupon-reminder')) {
    customElements.define('bb-coupon-reminder', class extends HTMLElement {
      static estimate(rule, cart, code) {
        const applied = (cart.discounts || []).filter(discount => discount.code.toUpperCase() === code.toUpperCase()).reduce((sum, discount) => sum + discount.amount, 0);
        if (applied > 0) return {state:'applied', amount:applied};
        const eligible = cart.items.filter(item => rule.scope === 'all' || rule.scope === 'products' && (rule.products || []).includes(item.productId) || rule.scope === 'collections' && (item.collectionIds || []).some(id => (rule.collections || []).includes(id)));
        if (!eligible.length) return {state:'ineligible', amount:0};
        if (cart.total < rule.minimum) return {state:'minimum', amount:0};
        if (rule.kind === 'gift' || !rule.combine && (cart.discounts || []).length > 0) return {state:'pending', amount:0};
        const itemsTotal = cart.items.reduce((sum, item) => sum + item.final, 0);
        const base = Math.min(cart.total, Math.round(eligible.reduce((sum, item) => sum + item.final, 0) * (itemsTotal > 0 ? Math.min(1, cart.total / itemsTotal) : 0)));
        const value = Number(rule.value);
        const amount = rule.kind === 'percent' && value > 0 && value <= 100 ? Math.round(base * value / 100) : rule.kind === 'fixed' && value > 0 ? Math.min(base, Math.round(value * 100)) : 0;
        return {state:amount > 0 ? 'estimate' : 'pending', amount};
      }
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        document.addEventListener('bb:coupon-state', () => this.refresh(), options);
        this.refresh();
      }
      disconnectedCallback() { this.controller.abort(); }
      refresh() {
        const library = document.querySelector('bb-coupon-library');
        this.messages = library?.dataset;
        this.coupon = library?.getCoupon ? library.getCoupon() : validCoupon(readCoupon(), library);
        const selectedCard = this.coupon && [...library.querySelectorAll('[data-coupon-card]')].find(item => signatureOf(item) === this.coupon.signature);
        this.automatic = Boolean(selectedCard && modeOf(selectedCard, library) === 'yampi' && !this.coupon.manualOnly);
        this.hidden = !this.coupon;
        const summary = this.closest('.bb-cart-summary');
        // The reminder also carries data-applied-code; only restore actual discount rows.
        summary?.querySelectorAll('.bb-cart-summary__row[data-applied-code]').forEach(row => { row.hidden = false; });
        this.dataset.checkoutPending = 'false';
        this.dataset.appliedCode = '';
        if (this.hidden) { this.dispatchEvent(new CustomEvent('bb:coupon-summary',{bubbles:true})); return; }
        const legacy = this.querySelector('[data-reminder-text]');
        if (legacy) { legacy.textContent = phrase(this.automatic ? this.messages.reminderAuto : this.messages.reminder, this.coupon); return; }
        this.querySelector('[data-reminder-code]').textContent = this.coupon.code;
        this.querySelector('[data-reminder-benefit]').textContent = this.coupon.benefit;
        this.querySelector('[data-reminder-amount]').textContent = '';
        const note = this.querySelector('[data-reminder-note]');
        note.hidden = true;
        note.textContent = this.dataset.pendingNote;
        try {
          const card = [...library.querySelectorAll('[data-coupon-card]')].find(item => signatureOf(item) === this.coupon.signature);
          const rule = JSON.parse(card.dataset.cartRule);
          const cart = JSON.parse(summary.querySelector('[data-bb-cart-data]').textContent);
          const result = this.constructor.estimate(rule, cart, this.coupon.code);
          this.dataset.checkoutPending = String(result.state === 'estimate' || result.state === 'pending');
          this.dataset.appliedCode = result.state === 'applied' ? this.coupon.code : '';
          const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR', {style:'currency', currency:cart.currency || 'BRL'}).format(amount / 100);
          const amount = this.querySelector('[data-reminder-amount]');
          amount.textContent = result.amount && (result.state === 'applied' || this.dataset.showEstimate !== 'false') ? `−${money(result.amount)}` : '';
          this.querySelector('[data-reminder-benefit]').textContent = rule.kind === 'percent' ? `−${rule.value}%` : this.coupon.benefit;
          note.textContent = this.dataset[`${result.state}Note`] || this.dataset.pendingNote;
          if (result.state === 'minimum') note.textContent = this.dataset.minimumNote.replace('[amount]', money(rule.minimum));
          if (result.state === 'applied') summary.querySelectorAll('.bb-cart-summary__row[data-applied-code]').forEach(row => { row.hidden = row.dataset.appliedCode.toUpperCase() === this.coupon.code.toUpperCase(); });
          const hasConstraint = ['minimum','ineligible'].includes(result.state);
          if (!hasConstraint && result.state !== 'applied' && this.dataset.customNote !== undefined) note.textContent = this.dataset.customNote;
          if (!hasConstraint && this.dataset.showNote === 'false') note.textContent = '';
          if (result.state !== 'applied' && !this.automatic) note.textContent += ` ${this.dataset.manualNote}`;
          note.hidden = true;
          const info = this.querySelector('[data-coupon-info]');
          if (info) { info.hidden = this.dataset.showNote === 'false' || !note.textContent.trim(); info.dataset.cartInfo = note.textContent.trim(); }
        } catch {}
        this.dispatchEvent(new CustomEvent('bb:coupon-summary',{bubbles:true}));
      }
    });
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  if (!customElements.get('bb-cart-quantity')) {
    customElements.define('bb-cart-quantity', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.addEventListener('click', (event) => {
          const button = event.target.closest('[data-step]');
          if (!button || this.getAttribute('aria-busy') === 'true') return;
          const input = this.querySelector('input');
          const current = Number.parseInt(input.value, 10);
          const max = input.hasAttribute('max') ? Number(input.max) : Number.MAX_SAFE_INTEGER;
          const next = Math.min(max, Math.max(0, current + Number(button.dataset.step)));
          if (!Number.isFinite(next) || current === next) return;
          input.value = String(next);
          input.dispatchEvent(new Event('change', {bubbles:true}));
        }, {signal:this.controller.signal});
        this.closest('line-item')?.addEventListener('line-item:will-change', () => this.setAttribute('aria-busy','true'), {signal:this.controller.signal});
        this.closest('line-item')?.addEventListener('line-item:change', () => this.removeAttribute('aria-busy'), {signal:this.controller.signal});
        this.closest('line-item')?.addEventListener('line-item:error', () => this.removeAttribute('aria-busy'), {signal:this.controller.signal});
      }
      disconnectedCallback() { this.controller.abort(); }
    });
  }
if (!customElements.get('bb-cart-offers')) {
  customElements.define('bb-cart-offers', class extends HTMLElement {
    static excluded(offer, item) {
      return (offer.excludedProducts || []).includes(item.productId) || (item.collectionIds || []).some(id => (offer.excludedCollections || []).includes(id));
    }
    static accepts(offer, item) {
      return !this.excluded(offer,item) && (offer.scope === 'all' || offer.scope === 'products' && (offer.products || []).includes(item.productId) || offer.scope === 'collections' && (item.collectionIds || []).some(id => (offer.collections || []).includes(id)));
    }
    static evaluate(offer, cart) {
      const bundle = ['buy_x_get_y','nth_percent','nth_price'].includes(offer.kind);
      const percent = ['percent','progressive_percent','nth_percent'].includes(offer.kind);
      const fixed = ['fixed','progressive_fixed'].includes(offer.kind);
      const accepts = item => this.accepts(offer,item);
      const items = cart.items.filter(item => item.final > 0 && (offer.kind !== 'gift' || item.productId !== offer.giftId) && accepts(item));
      const metric = bundle ? 'quantity' : offer.metric;
      const buy = Number(offer.buy), receive = Number(offer.receive);
      let target = bundle ? buy + receive : Math.round(Number(offer.threshold) * (metric === 'value' ? 100 : 1));
      let current = items.reduce((sum,item) => sum + (metric === 'value' ? (offer.basis === 'checkout_pix' ? item.checkoutPix ?? item.final : offer.basis === 'checkout_card' ? item.checkoutCard ?? item.final : offer.basis === 'final' ? item.final : item.original) : item.quantity),0);
      let buyMissing = 0, rewardMissing = 0;
      if (bundle && offer.rewardScope === 'same') {
        const freeRewards = cart.items.filter(item => item.original > 0 && item.final === 0 && accepts(item)).reduce((sum,item) => sum + item.quantity,0);
        current = Math.min(buy,current) + Math.min(receive,Math.max(0,current - buy) + freeRewards);
      }
      if (bundle && offer.rewardScope === 'products') {
        const rewards = offer.rewardProducts || [];
        const rewardOnly = cart.items.filter(item => item.original > 0 && !this.excluded(offer,item) && rewards.includes(item.productId) && (!accepts(item) || item.final <= 0)).reduce((sum,item) => sum + item.quantity,0);
        const both = items.filter(item => rewards.includes(item.productId)).reduce((sum,item) => sum + item.quantity,0);
        const purchaseOnly = items.filter(item => !rewards.includes(item.productId)).reduce((sum,item) => sum + item.quantity,0);
        const reservedForReward = Math.max(0,receive - rewardOnly);
        buyMissing = Math.max(0,buy - purchaseOnly - Math.max(0,both - reservedForReward));
        rewardMissing = Math.max(0,receive - rewardOnly - both);
        current = target - buyMissing - rewardMissing;
      }
      const validScope = offer.scope === 'all' || offer.scope === 'products' && offer.products?.length > 0 || offer.scope === 'collections' && offer.collections?.length > 0;
      const validBundle = !bundle || Number.isInteger(buy) && buy > 0 && Number.isInteger(receive) && receive > 0 && (offer.rewardScope === 'same' || offer.rewardScope === 'products' && offer.rewardProducts?.length > 0);
      const known = ['percent','fixed','progressive_percent','progressive_fixed','gift','shipping','buy_x_get_y','nth_percent','nth_price'].includes(offer.kind);
      const valid = Boolean(Number.isFinite(target) && target > 0 && (metric !== 'quantity' || bundle || Number.isInteger(Number(offer.threshold))) && validScope && validBundle && ['value','quantity'].includes(metric) && known && (offer.kind !== 'gift' || Number(offer.giftId) > 0) && (!bundle || Number.isInteger(Number(offer.maxGroups || 0)) && Number(offer.maxGroups || 0) >= 0) && (!(percent || fixed) || Number(offer.value) > 0) && (!percent || Number(offer.value) <= 100) && (offer.kind !== 'nth_price' || Number.isFinite(Number(offer.value)) && Number(offer.value) >= 0));
      return {offer,valid,current,target,metric,buyMissing,rewardMissing,reached:valid && current >= target,progress:valid ? Math.max(0,Math.min(100,current / target * 100)) : 0,remaining:Math.max(0,target - current)};
    }
    static savings(offer, cart) {
      const normalize = value => String(value || '').trim().toLocaleUpperCase();
      const applied = (cart.discounts || []).filter(discount => normalize(discount.code) === normalize(offer.checkoutName || offer.title)).reduce((sum,discount) => sum + Number(discount.amount || 0),0);
      if (applied > 0) return {state:'applied',amount:applied};
      const evaluation = this.evaluate(offer,cart);
      if (!evaluation.valid || !evaluation.reached) return {state:'locked',amount:0};
      const accepts = item => this.accepts(offer,item);
      const sum = cart.items.reduce((total,item) => total + item.final,0);
      const ratio = sum > 0 ? Math.min(1,(Number.isFinite(cart.total) ? cart.total : sum) / sum) : 0;
      const eligible = cart.items.filter(item => item.final > 0 && accepts(item));
      const base = Math.round(eligible.reduce((total,item) => total + item.final,0) * ratio);
      const value = Number(offer.value);
      if (['percent','progressive_percent'].includes(offer.kind)) return {state:'estimate',amount:Math.round(base * value / 100)};
      if (['fixed','progressive_fixed'].includes(offer.kind)) return {state:'estimate',amount:Math.min(base,Math.round(value * 100))};
      if (offer.kind === 'shipping') return {state:'pending',amount:0};
      const buckets = [];
      for (const item of cart.items) {
        if (item.original <= 0 || item.quantity <= 0 || this.excluded(offer,item)) continue;
        const purchase = item.final > 0 && accepts(item);
        const reward = offer.kind === 'gift' ? item.productId === offer.giftId : offer.rewardScope === 'products' ? (offer.rewardProducts || []).includes(item.productId) : accepts(item);
        if (!purchase && !reward) continue;
        const final = Math.round(item.final * ratio), unit = Math.floor(final / item.quantity), remainder = final % item.quantity;
        if (item.quantity > remainder) buckets.push({purchase,reward,price:unit,quantity:item.quantity - remainder});
        if (remainder > 0) buckets.push({purchase,reward,price:unit+1,quantity:remainder});
      }
      buckets.sort((a,b) => a.price - b.price || Number(a.purchase) - Number(b.purchase));
      if (offer.kind === 'gift') {
        const gift = buckets.find(bucket => bucket.reward);
        return {state:gift ? 'estimate' : 'pending',amount:gift?.price || 0};
      }
      let purchaseCount = buckets.filter(bucket => bucket.purchase).reduce((n,bucket) => n + bucket.quantity,0);
      const rewardCount = buckets.filter(bucket => bucket.reward).reduce((n,bucket) => n + bucket.quantity,0);
      const totalCount = buckets.reduce((n,bucket) => n + bucket.quantity,0);
      const groups = Math.min(Math.floor(purchaseCount / offer.buy),Math.floor(rewardCount / offer.receive),Math.floor(totalCount / (offer.buy + offer.receive)),Number(offer.maxGroups) > 0 ? Number(offer.maxGroups) : Infinity);
      let remaining = groups * offer.receive, amount = 0;
      for (const bucket of buckets) {
        if (!bucket.reward || remaining <= 0) continue;
        const count = Math.min(remaining,bucket.quantity,bucket.purchase ? Math.max(0,purchaseCount - groups * offer.buy) : Infinity);
        const unitDiscount = offer.kind === 'buy_x_get_y' ? bucket.price : offer.kind === 'nth_percent' ? Math.round(bucket.price * value / 100) : Math.max(0,bucket.price - Math.round(value * 100));
        amount += count * unitDiscount;
        remaining -= count;
        if (bucket.purchase) purchaseCount -= count;
      }
      return {state:'estimate',amount:Math.min(Math.round(sum * ratio),amount),groups};
    }
    static visible(evaluations) {
      const valid = evaluations.filter(item => item.valid);
      const chosen = valid.filter(item => !item.offer.group);
      const groups = new Map();
      valid.filter(item => item.offer.group).forEach(item => {
        const key = JSON.stringify([item.offer.group,item.offer.kind,item.metric,item.offer.basis || 'original',item.offer.scope,[...(item.offer.products || [])].sort(),[...(item.offer.collections || [])].sort(),[...(item.offer.excludedProducts || [])].sort(),[...(item.offer.excludedCollections || [])].sort()]);
        if (!groups.has(key)) groups.set(key,[]);
        groups.get(key).push(item);
      });
      groups.forEach(items => {
        const discounted = ['percent','fixed','progressive_percent','progressive_fixed'].includes(items[0].offer.kind);
        const reached = items.filter(item => item.reached).sort((a,b) => discounted ? Number(b.offer.value) - Number(a.offer.value) || b.target - a.target : b.target - a.target)[0];
        if (reached) chosen.push(reached);
        const next = items.filter(item => !item.reached && (!reached || !discounted || Number(item.offer.value) > Number(reached.offer.value))).sort((a,b) => b.progress - a.progress || a.target - b.target)[0];
        if (next) chosen.push(next);
      });
      return chosen;
    }
    connectedCallback() {
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      const refresh = () => queueMicrotask(() => this.refresh());
      document.addEventListener('bb:coupon-summary',refresh,options);
      document.addEventListener('bb:coupon-state',refresh,options);
      document.addEventListener('cart:change',refresh,options);
      document.addEventListener('bb:cart-rendered',refresh,options);
      customElements.whenDefined('bb-cart-pricing').then(refresh);
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    refresh() {
      if (!this.isConnected) return;
      try {
        const isProduct = this.dataset.context === 'product';
        const dataNode = isProduct ? document.querySelector('cart-drawer [data-bb-cart-shared] [data-bb-cart-data]') || this.querySelector('[data-bb-cart-data]') : this.querySelector('[data-bb-cart-data]');
        let cart = JSON.parse(dataNode.textContent);
        const formatter = new Intl.NumberFormat(document.documentElement.lang || 'pt-BR',{style:'currency',currency:cart.currency || 'BRL'});
        const Pricing = customElements.get('bb-cart-pricing');
        const root = this.closest('cart-drawer') || this.closest('.cart') || this;
        const offers = [...root.querySelectorAll('[data-offer]')].map(element => JSON.parse(element.dataset.offer));
        const needsCheckout = offers.some(offer => ['checkout_pix','checkout_card'].includes(offer.basis));
        if (needsCheckout && !Pricing) {this.hidden = true;return;}
        if (needsCheckout) {
          const control = isProduct ? this : root.querySelector('bb-cart-pricing');
          const coupon = document.querySelector('bb-coupon-library')?.getPricingCoupon?.();
          const model = Pricing.calculate(cart,offers,coupon,{enabled:control?.dataset.enabled!=='false',pixCombine:control?.dataset.pixCombine!=='false',pixPercent:Number(control?.dataset.pixPercent ?? 10)});
          cart = {...cart,items:cart.items.map((item,index)=>({...item,checkoutCard:model.card.items[index].final,checkoutPix:model.pix.items[index].final}))};
        }
        const evaluations = [...this.querySelectorAll('[data-offer]')].map(element => ({...this.constructor.evaluate(JSON.parse(element.dataset.offer),cart),element}));
        const productItem = {productId:Number(this.dataset.productId),collectionIds:JSON.parse(this.dataset.collectionIds || '[]')};
        const productAccepts = offer => this.constructor.accepts(offer,productItem) && (offer.kind !== 'gift' || offer.giftId !== productItem.productId);
        const candidates = this.constructor.visible(isProduct ? evaluations.filter(result => productAccepts(result.offer)) : evaluations);
        const groupKey = result => JSON.stringify([result.offer.group,result.offer.kind,result.metric,result.offer.basis || 'original',result.offer.scope,[...(result.offer.products || [])].sort(),[...(result.offer.collections || [])].sort(),[...(result.offer.excludedProducts || [])].sort(),[...(result.offer.excludedCollections || [])].sort()]);
        const sameGroup = (a,b) => a.offer.group && groupKey(a) === groupKey(b);
        const chosen = candidates.filter(result => !result.offer.group || result.reached || !candidates.some(other => other.reached && sameGroup(other,result)));
        const message = result => {
          const remaining = result.metric === 'value' ? formatter.format(result.remaining / 100) : `${result.remaining} ${result.remaining === 1 ? this.dataset.itemLabel : this.dataset.itemsLabel}`;
          return (result.reached ? result.element.dataset.after : result.element.dataset.before).replaceAll('[restante]',remaining).replaceAll('[beneficio]',result.element.dataset.benefit).replaceAll('[compra]',String(result.offer.buy)).replaceAll('[recebe]',String(result.offer.receive)).replaceAll('[total]',String(Number(result.offer.buy) + Number(result.offer.receive)));
        };
        evaluations.forEach(result => {
          const element = result.element;
          element.hidden = !chosen.includes(result);
          if (!result.valid && this.dataset.editor === 'true' && (!isProduct || productAccepts(result.offer))) {
            element.hidden = evaluations.some(other => other.offer.blockId === result.offer.blockId && (other.valid || evaluations.indexOf(other) < evaluations.indexOf(result)));
            element.querySelector('[data-offer-message]').textContent = this.dataset.invalidLabel;
            return;
          }
          if (element.hidden) return;
          element.dataset.reached = String(result.reached);
          element.querySelector('[data-offer-message]').textContent = message(result);
          const next = result.reached && result.offer.group ? candidates.find(other => !other.reached && sameGroup(other,result)) : null;
          const nudge = element.querySelector('[data-offer-next]');
          if (nudge) {
            const cardReached = result.offer.kind==='gift' && result.offer.basis==='checkout_pix' && !result.reached && this.constructor.evaluate({...result.offer,basis:'checkout_card'},cart).reached;
            nudge.hidden = !next && !cardReached;
            nudge.textContent = next ? message(next) : cardReached ? this.dataset.cardReached : '';
          }
          const progress = element.querySelector('[data-offer-progress]');
          if (progress) progress.value = next ? next.progress : result.progress;
        });
        this.querySelectorAll('[data-offer-block]').forEach(block => { block.hidden = ![...block.querySelectorAll('[data-offer]')].some(element => !element.hidden); });
        this.hidden = !evaluations.some(result => !result.element.hidden);
      } catch { this.hidden = true; }
    }
  });
}
if (!customElements.get('bb-cart-timer')) {
  customElements.define('bb-cart-timer', class extends HTMLElement {
    static parseDate(value) {
      const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec(value);
      if (!match) return NaN;
      const [,year,month,day,hour,minute] = match.map(Number);
      const date = new Date(Date.UTC(year,month-1,day,hour,minute));
      if (year < 2000 || month < 1 || month > 12 || day < 1 || hour > 23 || minute > 59 || date.getUTCMonth() !== month-1 || date.getUTCDate() !== day) return NaN;
      return date.getTime() + 10800000;
    }
    connectedCallback() {
      this.controller = new AbortController();
      this.drawer = this.closest('cart-drawer');
      this.drawer?.addEventListener('dialog:after-show', () => this.start(), {signal:this.controller.signal});
      document.addEventListener('visibilitychange', () => { if (!document.hidden && this.deadline) this.render(); }, {signal:this.controller.signal});
      if (this.drawer?.hasAttribute('open') || this.dataset.editor === 'true') this.start();
    }
    start() {
      if (this.deadline) { this.render(); return; }
      if (this.dataset.mode === 'fixed') {
        this.deadline = this.constructor.parseDate(this.dataset.end);
      } else {
        const duration = Number(this.dataset.seconds) * 1000;
        if (!Number.isFinite(duration) || duration <= 0) return;
        const key = `blocobox.cart-timer.v1:${this.dataset.section}:${duration}`;
        try {
          const stored = Number(sessionStorage.getItem(key));
          this.deadline = stored > 0 && stored <= Date.now() + duration ? stored : Date.now() + duration;
          if (stored !== this.deadline) sessionStorage.setItem(key, String(this.deadline));
        } catch { this.hidden = true; return; }
      }
      if (!Number.isFinite(this.deadline)) return;
      this.render();
      if (this.deadline > Date.now()) this.interval = setInterval(() => { if (!document.hidden) this.render(); }, 1000);
    }
    render() {
      const seconds = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
      const expired = seconds === 0;
      this.hidden = expired && this.dataset.hideExpired === 'true';
      const message = expired ? this.dataset.expired : this.dataset.message;
      const parts = message.split(/\{\{timer\}\}|\[timer\]/);
      this.querySelector('[data-timer-prefix]').textContent = parts[0];
      this.querySelector('[data-timer-value]').textContent = expired ? '' : `${String(Math.floor(seconds / 60)).padStart(2,'0')}:${String(seconds % 60).padStart(2,'0')}`;
      this.querySelector('[data-timer-suffix]').textContent = parts.slice(1).join('');
      if (expired) clearInterval(this.interval);
    }
    disconnectedCallback() { this.controller.abort(); clearInterval(this.interval); }
  });
}

if (!customElements.get('bb-cart-feedback')) {
    customElements.define('bb-cart-feedback',class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.tip = this.querySelector('[role="status"]');
        const options = {signal:this.controller.signal};
        this.root = this.closest('cart-drawer') || this.closest('.bb-cart-summary') || this.closest('bb-product-offers');
        this.root?.addEventListener('click',event => {
          const anchor = event.target.closest('[data-cart-info]');
          if (anchor) this.show(anchor,anchor.dataset.cartInfo);
        },options);
        document.addEventListener('pointerdown',event => { if (this.anchor && !event.composedPath().includes(this.anchor)) this.close(); },options);
        document.addEventListener('keydown',event => { if (event.key === 'Escape' && !this.tip.hidden) { event.stopPropagation(); this.close(); } },{...options,capture:true});
        this.root?.shadowRoot?.addEventListener('scroll',() => this.close(),{...options,capture:true});
        window.addEventListener('scroll',() => this.close(),{...options,capture:true});
        window.addEventListener('resize',() => this.close(),options);
        document.addEventListener('bb:summary-toggle',() => this.close(),options);
        this.root?.addEventListener('dialog:before-hide',() => this.close(),options);
      }
      show(anchor,message) {
        if (!message || !anchor?.isConnected) return;
        this.close();
        this.anchor = anchor;
        this.tip.textContent = message;
        this.tip.hidden = false;
        this.tip.showPopover?.();
        const rect = anchor.getBoundingClientRect(), box = this.tip.getBoundingClientRect();
        this.tip.style.left = `${Math.max(12,Math.min(innerWidth-box.width-12,rect.left-12))}px`;
        this.tip.style.top = `${Math.max(12,Math.min(innerHeight-box.height-12,rect.top-box.height-8 >= 12 ? rect.top-box.height-8 : rect.bottom+8))}px`;
        this.timer = setTimeout(() => this.close(),4000);
      }
      close() {
        clearTimeout(this.timer);
        if (!this.tip.hidden) this.tip.hidePopover?.();
        this.tip.hidden = true;
        this.tip.textContent = '';
        this.anchor = null;
      }
      disconnectedCallback() { this.close(); this.controller.abort(); }
    });
  }

if (!customElements.get('bb-cashback-popover')) {
    customElements.define('bb-cashback-popover',class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        this.button = this.querySelector('button');
        this.tip = this.querySelector('[role="tooltip"]');
        this.tip.id = `bb-cashback-${(crypto.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`)}`;
        this.button.setAttribute('aria-controls',this.tip.id);
        this.button.setAttribute('aria-describedby',this.tip.id);
        this.button.addEventListener('click',() => {
          if (this.button.getAttribute('aria-expanded') === 'true') { this.close(); return; }
          this.tip.hidden = false;
          this.tip.showPopover?.();
          this.button.setAttribute('aria-expanded','true');
          this.position();
        },options);
        this.tip.addEventListener('toggle',event => {
          if (event.newState === 'closed') { this.tip.hidden = true; this.button.setAttribute('aria-expanded','false'); }
        },options);
        this.addEventListener('keydown',event => {
          if (event.key === 'Escape' && !this.tip.hidden) { event.stopPropagation(); this.close(); }
        },options);
        document.addEventListener('pointerdown',event => { if (!event.composedPath().includes(this)) this.close(); },options);
        this.closest('cart-drawer')?.shadowRoot?.addEventListener('scroll',() => this.close(),{...options,capture:true});
        window.addEventListener('resize',() => this.close(),options);
        document.addEventListener('bb:summary-toggle',() => this.close(),options);
        window.addEventListener('scroll',() => this.close(),{...options,capture:true});
        this.closest('cart-drawer')?.addEventListener('dialog:before-hide',() => this.close(),options);
      }
      position() {
        const anchor = this.button.getBoundingClientRect(), box = this.tip.getBoundingClientRect();
        this.tip.style.left = `${Math.max(12,Math.min(innerWidth-box.width-12,anchor.left-16))}px`;
        this.tip.style.top = `${anchor.top-box.height-8 >= 12 ? anchor.top-box.height-8 : anchor.bottom+8}px`;
      }
      close() {
        if (this.tip.hidden) return;
        this.tip.hidePopover?.();
        this.tip.hidden = true;
        this.button.setAttribute('aria-expanded','false');
      }
      disconnectedCallback() { this.controller.abort(); }
    });
  }

if (!customElements.get('bb-cart-summary-toggle')) {
    customElements.define('bb-cart-summary-toggle', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.drawer = this.closest('cart-drawer');
        this.button = this.querySelector('button');
        this.storageKey = `blocobox.cart-summary:${this.dataset.section}:${this.dataset.default}`;
        let saved = this.drawer?.dataset.summaryOpen;
        if (this.dataset.editor === 'true') saved = undefined;
        else if (saved === undefined) { try { saved = sessionStorage.getItem(this.storageKey); } catch {} }
        this.apply(saved === 'true' || saved == null && this.dataset.default === 'open');
        this.button.addEventListener('click', () => {
          const open = this.button.getAttribute('aria-expanded') !== 'true';
          this.apply(open);
          if (this.dataset.editor !== 'true') { try { sessionStorage.setItem(this.storageKey,String(open)); } catch {} }
          if (open) {
            const body = this.drawer?.shadowRoot?.querySelector('[part="body"]');
            const panel = document.getElementById(this.button.getAttribute('aria-controls'));
            if (body && panel) body.scrollTop += panel.getBoundingClientRect().top - body.getBoundingClientRect().top - 16;
          }
          this.dispatchEvent(new CustomEvent('bb:summary-toggle',{bubbles:true,detail:{open}}));
        },{signal:this.controller.signal});
      }
      apply(open) {
        this.button.setAttribute('aria-expanded',String(open));
        const panel = document.getElementById(this.button.getAttribute('aria-controls'));
        if (panel) panel.hidden = !open;
        if (this.drawer) this.drawer.dataset.summaryOpen = String(open);
      }
      disconnectedCallback() { this.controller.abort(); }
    });
  }

if (!customElements.get('bb-cart-pricing')) {
    customElements.define('bb-cart-pricing',class extends HTMLElement {
      static accepts(rule,item) {
        return customElements.get('bb-cart-offers').accepts(rule,item);
      }
      static allocate(amount,weights) {
        const total = weights.reduce((sum,value) => sum+value,0);
        amount = Math.max(0,Math.min(total,Math.round(amount)));
        if (!total || !amount) return weights.map(() => 0);
        const shares = weights.map(value => amount*value/total);
        const result = shares.map(Math.floor);
        let remainder = amount-result.reduce((sum,value) => sum+value,0);
        const order = shares.map((value,index) => ({index,fraction:value-result[index]})).sort((a,b) => b.fraction-a.fraction || a.index-b.index);
        for (const item of order) { if (remainder-- <= 0) break; result[item.index]++; }
        return result;
      }
      static deduction(rule,state,cart) {
        const weights = state.items.map(item => this.accepts(rule,item) ? item.final : 0);
        const base = weights.reduce((sum,value) => sum+value,0);
        const value = Number(rule.value);
        if (['percent','progressive_percent','fixed','progressive_fixed','pix'].includes(rule.kind)) {
          const fixed = rule.kind.includes('fixed');
          if (!Number.isFinite(value) || value <= 0 || !fixed && value > 100) return weights.map(() => 0);
          const amount = fixed ? Math.min(base,Math.round(value*100)) : rule.kind === 'pix' ? base-Math.round(base*(100-value)/100) : Math.round(base*value/100);
          return this.allocate(amount,weights);
        }
        const allocations = weights.map(() => 0), buckets = [];
        allocations.freeUnits = weights.map(() => 0);
        state.items.forEach((item,index) => {
          if (item.original <= 0 || item.quantity <= 0 || customElements.get('bb-cart-offers').excluded(rule,item)) return;
          const purchase = item.final > 0 && this.accepts(rule,item);
          const reward = rule.kind === 'gift' ? item.productId === rule.giftId : rule.rewardScope === 'products' ? (rule.rewardProducts || []).includes(item.productId) : this.accepts(rule,item);
          if (!purchase && !reward) return;
          const unit = Math.floor(item.final/item.quantity), remainder = item.final%item.quantity;
          if (item.quantity > remainder) buckets.push({index,purchase,reward,price:unit,quantity:item.quantity-remainder});
          if (remainder) buckets.push({index,purchase,reward,price:unit+1,quantity:remainder});
        });
        buckets.sort((a,b) => a.price-b.price || Number(a.purchase)-Number(b.purchase));
        if (rule.kind === 'gift') {
          const gift = buckets.find(bucket => bucket.reward);
          if (gift) { allocations[gift.index] = gift.price; allocations.freeUnits[gift.index] = gift.price > 0 ? 1 : 0; }
          return allocations;
        }
        let purchases = buckets.filter(bucket => bucket.purchase).reduce((sum,bucket) => sum+bucket.quantity,0);
        const rewards = buckets.filter(bucket => bucket.reward).reduce((sum,bucket) => sum+bucket.quantity,0);
        const units = buckets.reduce((sum,bucket) => sum+bucket.quantity,0);
        const groups = Math.min(Math.floor(purchases/rule.buy),Math.floor(rewards/rule.receive),Math.floor(units/(rule.buy+rule.receive)),Number(rule.maxGroups) > 0 ? rule.maxGroups : Infinity);
        let remaining = groups*rule.receive;
        for (const bucket of buckets) {
          if (!bucket.reward || remaining <= 0) continue;
          const count = Math.min(remaining,bucket.quantity,bucket.purchase ? Math.max(0,purchases-groups*rule.buy) : Infinity);
          const discount = rule.kind === 'buy_x_get_y' ? bucket.price : rule.kind === 'nth_percent' ? Math.round(bucket.price*value/100) : Math.max(0,bucket.price-Math.round(value*100));
          allocations[bucket.index] += count*discount;
          if (discount === bucket.price && discount > 0) allocations.freeUnits[bucket.index] += count;
          remaining -= count;
          if (bucket.purchase) purchases -= count;
        }
        return allocations;
      }
      static calculate(cart,offers,coupon,options={}) {
        const Offers = customElements.get('bb-cart-offers');
        const normalize = value => String(value || '').trim().toUpperCase();
        const actual = (cart.discounts || []).filter(row => row.amount > 0);
        const applied = name => actual.filter(row => normalize(row.code) === normalize(name)).reduce((sum,row) => sum+row.amount,0);
        const allocatedTotals = cart.items.map(item => item.afterDiscounts);
        const originalTotals = allocatedTotals.every(Number.isFinite) && allocatedTotals.reduce((sum,value)=>sum+value,0) === cart.total ? allocatedTotals : this.allocate(cart.total,cart.items.map(item => item.final));
        const items = cart.items.map((item,index) => ({...item,final:originalTotals[index]}));
        let rules = [];
        if (options.enabled !== false) {
          const selected = Offers.visible(offers.map(offer => Offers.evaluate(offer,cart))).filter(result => result.reached && result.offer.includeInTotal !== false && !['gift','shipping'].includes(result.offer.kind));
          const names = new Set();
          for (const result of selected) {
            const rule = result.offer, name = normalize(rule.checkoutName || rule.title);
            if (names.has(name) || applied(name) || actual.length && !rule.combine) continue;
            names.add(name);
            rules.push(rule);
          }
          if (coupon?.automatic && !applied(coupon.code) && ['percent','fixed'].includes(coupon.kind) && Number(coupon.value) > 0 && (coupon.kind !== 'percent' || coupon.value <= 100) && cart.total >= Number(coupon.minimum || 0) && (!actual.length || coupon.combine) && items.some(item => item.final > 0 && this.accepts(coupon,item))) {
            // An offer with the exact coupon name represents the same campaign.
            rules = rules.filter(rule => normalize(rule.checkoutName || rule.title) !== normalize(coupon.code));
            rules.push({...coupon,id:'coupon',source:'coupon'});
          }
        }
        const priority = rule => rule.kind === 'pix' ? 4 : rule.source === 'coupon' ? 3 : ['buy_x_get_y','nth_percent','nth_price','gift'].includes(rule.kind) ? 0 : 1;
        const run = selected => {
          const state = {total:cart.total,items:items.map(item => ({...item})),rows:[]};
          for (const rule of [...selected].sort((a,b) => priority(a)-priority(b))) {
            const allocations = this.deduction(rule,state,cart);
            const amount = allocations.reduce((sum,value) => sum+value,0);
            if (!amount) continue;
            state.items.forEach((item,index) => { item.final -= allocations[index]; });
            state.total -= amount;
            state.rows.push({id:rule.id,rule,amount,allocations,freeUnits:allocations.freeUnits || allocations.map(()=>0)});
          }
          return state;
        };
        const best = candidates => {
          const paths = [run(candidates.filter(rule => rule.combine)),...candidates.filter(rule => !rule.combine).map(rule => run([rule]))];
          return paths.reduce((winner,path) => path.total < winner.total ? path : winner);
        };
        let card = best(rules);
        const pixRule = {id:'pix',kind:'pix',scope:'all',value:Math.max(0,Math.min(50,Number(options.pixPercent ?? 10))),combine:options.pixCombine !== false};
        let pix = best([...rules,pixRule]);
        const cardRules = card.rows.map(row=>row.rule), pixRules = pix.rows.map(row=>row.rule);
        const benefitRules = options.enabled === false ? [] : offers.filter(rule=>['gift','shipping'].includes(rule.kind));
        const evaluateBenefits = (method,kind) => {
          const pricedCart = {...cart,items:cart.items.map((item,index)=>({...item,checkoutCard:card.items[index].final,checkoutPix:pix.items[index].final}))};
          const evaluated = benefitRules.filter(rule=>rule.kind===kind).map(rule=>{
            const effectiveRule = method==='card' && rule.basis==='checkout_pix' ? {...rule,basis:'checkout_card'} : rule;
            const result=Offers.evaluate(effectiveRule,pricedCart);
            if (kind==='shipping' && !rule.combine && (actual.length || (method==='card'?card:pix).rows.some(row=>row.amount>0))) result.reached=false;
            return {...result,offer:rule};
          });
          const seen = new Set();
          return Offers.visible(evaluated).filter(result=>{
            const key = kind==='gift' ? String(result.offer.giftId) : result.offer.id;
            if (!result.reached || seen.has(key)) return false;
            seen.add(key); return true;
          }).map(result=>result.offer);
        };
        let cardGifts = evaluateBenefits('card','gift'), pixGifts = evaluateBenefits('pix','gift');
        for (let attempt=0;attempt<=benefitRules.length;attempt++) {
          card = run([...cardRules,...cardGifts.filter(rule=>!applied(rule.checkoutName || rule.title))]);
          pix = run([...pixRules,...pixGifts.filter(rule=>!applied(rule.checkoutName || rule.title))]);
          const eligibleCard = new Set(evaluateBenefits('card','gift').map(rule=>rule.id));
          const eligiblePix = new Set(evaluateBenefits('pix','gift').map(rule=>rule.id));
          const remainingCard = cardGifts.filter(rule=>eligibleCard.has(rule.id)), remainingPix = pixGifts.filter(rule=>eligiblePix.has(rule.id));
          if (remainingCard.length===cardGifts.length && remainingPix.length===pixGifts.length) break;
          cardGifts=remainingCard; pixGifts=remainingPix;
        }
        card.benefits = [...cardGifts,...evaluateBenefits('card','shipping')];
        pix.benefits = [...pixGifts,...evaluateBenefits('pix','shipping')];
        card.displayItems = run(card.rows.filter(row=>row.id!=='coupon').map(row=>row.rule)).items;
        pix.displayItems = run(pix.rows.filter(row=>row.id!=='coupon').map(row=>row.rule)).items;
        return {card,pix,couponApplied:coupon ? applied(coupon.code) : 0};
      }
      connectedCallback() {
        this.controller = new AbortController();
        const options = {signal:this.controller.signal};
        const refresh = () => queueMicrotask(() => this.refresh());
        document.addEventListener('bb:coupon-summary',refresh,options);
        document.addEventListener('bb:coupon-state',refresh,options);
        document.addEventListener('cart:change',refresh,options);
        document.addEventListener('bb:cart-rendered',refresh,options);
        this.closest('cart-drawer')?.addEventListener('dialog:before-show',() => {
          document.querySelector('bb-coupon-library')?.refresh?.();
          refresh();
        },options);
        customElements.whenDefined('bb-cart-offers').then(refresh);
      }
      refresh() {
        if (!this.isConnected) return;
        const summary = this.closest('.bb-cart-summary'), root = this.closest('cart-drawer') || this.closest('.cart') || summary;
        try {
          const shared = this.closest('cart-drawer')?.querySelector('[data-bb-cart-shared] [data-bb-cart-data]');
          const cart = JSON.parse((shared || summary.querySelector('[data-bb-cart-data]')).textContent);
          const offerRoot = this.closest('cart-drawer') || document.querySelector('cart-drawer') || root;
          const offers = [...offerRoot.querySelectorAll('[data-offer]')].map(element => JSON.parse(element.dataset.offer));
          const coupon = document.querySelector('bb-coupon-library')?.getPricingCoupon?.();
          const model = this.constructor.calculate(cart,offers,coupon,{enabled:this.dataset.enabled !== 'false',pixCombine:this.dataset.pixCombine !== 'false',pixPercent:Number(this.dataset.pixPercent ?? 10)});
          const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'pt-BR',{style:'currency',currency:cart.currency || 'BRL'}).format(amount/100);
          const normalize = value => String(value || '').trim().toUpperCase();
          const write = (selector,value) => root.querySelectorAll(selector).forEach(element => { element.textContent = money(value); });
          const free = this.dataset.free, gift = this.dataset.gift;
          const methodLabel = (cardOnly,pixOnly) => cardOnly ? ` ${this.dataset.cardLabel}` : pixOnly ? ` ${this.dataset.pixLabel}` : '';
          write('[data-cart-card-total]',model.card.total);
          write('[data-cart-pix-total]',model.pix.total);
          const subtotal = cart.items.reduce((sum,item)=>sum+item.original,0);
          write('[data-cart-subtotal]',subtotal);
          root.querySelectorAll('[data-cart-subtotal]').forEach(element => element.classList.toggle('bb-cart-summary__subtotal-discounted',subtotal > model.pix.total));
          root.querySelectorAll('bb-payment-terms[data-cart-terms]').forEach(element => element.setAttribute('data-amount',model.card.total));
          root.querySelectorAll('[data-cart-cashback]').forEach(element => { element.textContent = `+${money(Math.round(model.card.total*.1))}`; });
          const pixDiscount = model.pix.rows.find(row => row.id === 'pix')?.amount || 0;
          write('[data-cart-pix-saving]',-pixDiscount);
          const pixRow = summary.querySelector('[data-cart-pix-row]');
          if (pixRow) pixRow.hidden = pixDiscount <= 0;
          const rows = summary.querySelector('[data-offer-savings-rows]');
          rows.replaceChildren();
          const actual = new Map();
          for (const discount of cart.discounts || []) {
            const key=normalize(discount.code), previous=actual.get(key);
            actual.set(key,{code:discount.code,amount:(previous?.amount || 0)+discount.amount});
          }
          const addRow = (rule,display,note='',secondary='') => {
            const row = document.createElement('div');
            row.className='bb-cart-summary__row bb-cart-offer-savings__row'; row.dataset.savingId=rule.id;
            const label=document.createElement('span'), title=document.createElement('span'), amount=document.createElement('span');
            label.className='bb-cart-offer-savings__label'; title.textContent=rule.summaryTitle || rule.title;
            label.append(title);
            if (rule.infoEnabled && rule.infoText) {
              const help=document.createElement('button'); help.type='button'; help.dataset.cartInfo=rule.infoText;
              help.setAttribute('aria-label',rule.title); help.append(this.querySelector('template[data-offer-info-icon]').content.cloneNode(true)); title.append(help);
            }
            if (note) { const detail=document.createElement('small');detail.textContent=note;label.append(detail); }
            amount.className='bb-cart-offer-savings__amount';amount.textContent=display;
            if (secondary) { const detail=document.createElement('small');detail.textContent=secondary;amount.append(detail); }
            row.append(label,amount);rows.append(row);
          };
          const monetary = new Map();
          for (const method of ['card','pix']) for (const saving of model[method].rows) {
            if (['coupon','pix'].includes(saving.id) || saving.rule.kind==='gift') continue;
            const row=monetary.get(saving.id) || {rule:saving.rule};row[method]=saving.amount;monetary.set(saving.id,row);
          }
          for (const saving of monetary.values()) {
            const cardOnly=saving.pix===undefined, pixOnly=saving.card===undefined;
            const different=!cardOnly&&!pixOnly&&saving.card!==saving.pix;
            addRow(saving.rule,`−${money(saving.pix ?? saving.card)}${methodLabel(cardOnly,pixOnly||different)}`,'',different?`−${money(saving.card)} ${this.dataset.cardLabel}`:'');
          }
          const benefits=new Map(), handledActual=new Set();
          for (const method of ['card','pix']) for (const rule of model[method].benefits) {
            const entry=benefits.get(rule.id)||{rule};entry[method]=true;benefits.set(rule.id,entry);
          }
          for (const benefit of benefits.values()) {
            const {rule}=benefit, cardOnly=!benefit.pix, pixOnly=!benefit.card;
            const saving=model.pix.rows.find(row=>row.id===rule.id) || model.card.rows.find(row=>row.id===rule.id);
            const key=normalize(rule.checkoutName || rule.title), confirmed=actual.get(key);
            if (confirmed) handledActual.add(key);
            const amount=saving?.amount || confirmed?.amount || 0;
            const isGift=rule.kind==='gift';
            const absent=isGift&&!cart.items.some(item=>item.productId===rule.giftId);
            const giftCount=[...benefits.values()].filter(entry=>entry.rule.kind==='gift').length;
            addRow({...rule,summaryTitle:isGift&&giftCount===1?gift:rule.title},`${free}${methodLabel(cardOnly,pixOnly)}`,absent?this.dataset.giftNote:'',amount?`−${money(amount)}${methodLabel(cardOnly,pixOnly)}`:'');
          }
          summary.querySelector('bb-cart-offer-savings').hidden = !rows.children.length;
          summary.querySelectorAll('[data-line-discount],.bb-cart-summary__row[data-applied-code]').forEach(row=>row.remove());
          for (const [key,discount] of actual) {
            if (handledActual.has(key)) continue;
            const row=document.createElement('div'), label=document.createElement('span'), amount=document.createElement('span');
            row.className='bb-cart-summary__row'; row.dataset.appliedCode=discount.code; row.dataset.lineDiscount='true';
            label.textContent=discount.code; amount.textContent=`−${money(discount.amount)}`;amount.className='bb-cart-offer-savings__amount';
            row.append(label,amount);summary.querySelector('[data-native-discounts]').append(row);
          }
          const reminder=summary.querySelector('bb-coupon-reminder');
          if (coupon && reminder && !reminder.hidden) {
            const pixCoupon=model.pix.rows.find(row=>row.id==='coupon'), cardCoupon=model.card.rows.find(row=>row.id==='coupon');
            const amount=model.couponApplied || pixCoupon?.amount || cardCoupon?.amount || 0;
            reminder.querySelector('[data-reminder-amount]').textContent=amount&&(model.couponApplied||reminder.dataset.showEstimate!=='false')?`−${money(amount)}${methodLabel(!model.couponApplied&&!pixCoupon&&cardCoupon,!model.couponApplied&&pixCoupon&&!cardCoupon)}`:'';
            if (model.couponApplied) summary.querySelectorAll('.bb-cart-summary__row[data-applied-code]').forEach(row=>{if(normalize(row.dataset.appliedCode)===normalize(coupon.code))row.hidden=true;});
            reminder.dataset.checkoutPending=String(!model.couponApplied&&!pixCoupon&&!cardCoupon);
          }
          const delivery=summary.querySelector('[data-cart-delivery]');
          if (delivery) {
            const ships=cart.items.some(item=>item.requiresShipping!==false);
            const qualified=method=>model[method].benefits.some(rule=>rule.kind==='shipping') || this.dataset.freeShippingEnabled==='true'&&model[method].items.reduce((sum,item)=>sum+(item.requiresShipping!==false?item.final:0),0)>=Number(this.dataset.shippingThreshold);
            const pixFree=ships&&qualified('pix'), cardFree=ships&&qualified('card');
            delivery.textContent=!ships?this.dataset.noShipping:pixFree&&cardFree?this.dataset.shipping:pixFree?`${this.dataset.shipping} ${this.dataset.pixLabel}`:cardFree?`${this.dataset.shipping} ${this.dataset.cardLabel}`:this.dataset.shippingAtCheckout;
            delivery.classList.toggle('bb-cart-summary__green',pixFree||cardFree);
          }
          root.querySelectorAll('[data-cart-line-price]').forEach(element=>{
            const index=cart.items.findIndex(item=>item.key===element.dataset.cartLinePrice);
            if (index<0) return;
            const item=cart.items[index], card=model.card.displayItems[index].final, pix=model.pix.displayItems[index].final;
            const price=element.querySelector('[data-line-pix]'), method=element.querySelector('[data-line-method]');
            const original=element.querySelector('[data-line-original]'), terms=element.querySelector('[data-line-terms]');
            price.textContent=pix===0?free:money(pix); element.dataset.free=String(pix===0);
            method.hidden=Number(this.dataset.pixPercent)===0||pix===0&&card===0; method.textContent=this.dataset.pixLabel;
            original.hidden=card>=item.original; original.textContent=money(item.original);
            element.querySelector('bb-payment-terms')?.setAttribute('data-amount',card);
            terms.hidden=card===0;
            const offerLabels=new Set();
            for (const payment of ['pix','card']) for (const row of model[payment].rows) {
              if (['coupon','pix'].includes(row.id)||!row.allocations[index]) continue;
              const opposite=payment==='pix'?'card':'pix';
              const both=model[opposite].rows.some(other=>other.id===row.id&&other.allocations[index]>0);
              const suffix=both?'':methodLabel(payment==='card',payment==='pix');
              const units=row.freeUnits?.[index] || 0;
              const label=units>0&&units<item.quantity?(units===1?this.dataset.freeUnit:this.dataset.freeUnits).replace('[count]',units):row.rule.title;
              offerLabels.add(label+suffix);
            }
            for (const discount of item.discounts || []) if (discount.amount>0&&normalize(discount.code)!==normalize(coupon?.code))offerLabels.add(discount.code);
            const label=element.querySelector('[data-line-offer-label]');
            label.hidden=!offerLabels.size; label.textContent=[...offerLabels].join(' · ');
          });
        } catch (error) { if (window.Shopify?.designMode) console.warn('Blocobox: confira as regras de preço do carrinho.',error); }
      }
      disconnectedCallback() { this.controller.abort(); }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
